/*=========  DRAWER  =========*/ 
/*=========    BY    ========*/ 
/*=========  MARMETO =========*/ 

//Preloader on page load
$(window).load(function() {
  $("#preLoader").delay(100).fadeOut(100);
});

//Make Nav Tabs Active
$(document).ready(function(){
  var $tab = $('.nav.nav-tabs a[data-toggle="tab"]');

  $tab.on('click', function() {
    $(this).parent().addClass('active').siblings().removeClass('active');
  });
});


$(document).ready(function() {

  var $drawerName, $variantId, $drawerImage, 
      $productId, $activeTab, $dataArray, $completedStep, 
      $pendingStep, $progressText, $stepCompleted,
      $chooseText, $step = $('.step-line'),
      $totalStep = $('.step-line').attr('data-total-step'),
      $variantArray = [],
      $pageHandle = $('#page_handle').val(),
      $closetBtn = $('.add-closet'),
      $drawerProductName = $('.section-subheading').attr('data-drawer-name');

  /*==========================================*\
			 	#Add To Closet			
  \*==========================================*/
  $closetBtn.on('click', function() {
	
    //Hide Overlay in mobile 
    $('.black-overlay').hide();
    
    //Get the drawer name, image and variant id
    $drawerName = $(this).attr('data-drawer');
    $drawerImage = $(this).parent().parent().parent().attr('data-image');
    $variantId = $(this).parent().find('.swatch input:checked').val();
    $productId = $(this).attr('data-product');
    
    //Hide Buttons
    $('.product_des_wrapper[drawer-count='+ $drawerName +']').find(".drawer__form").hide();
    $('.product_des_wrapper[drawer-count='+ $drawerName +']').find(".drawer__button").hide();
    $(function() {
      $('.product_des_wrapper').matchHeight();
    });
    
    //Update Active Tab Image
    $activeTab = $('.drawer-head[drawer-count="' + $drawerName + '"]');
    $activeTab.find('.drawer-link-details').hide();
    $activeTab.find('.drawer-active-link').show();
    $activeTab.find('.drawer-active-link .active-image-wrapper').show();
    $activeTab.find('.drawer-active-link img').attr('src', $drawerImage);
    $activeTab.find('.drawer-active-link .remove-item').attr('data-variant', $variantId);
        
    //Update tab class pending to completed
    $activeTab.attr('data-action', 'completed');
    
    //Update Progress Bar
    $completedStep = (100 * ($('.drawer-head[data-action="completed"]').length)) / $totalStep;
    $step.find('span').css('width', $completedStep + '%');
    
    //Update Progress Bar Text
    $progressText = $('.counter-text');
    $stepCompleted = $('.drawer-head[data-action="completed"]').length;
    if($stepCompleted > 0) {
      $progressText.html('Your Pack | ' + $stepCompleted + '/' + $totalStep);
    } else {
      $progressText.html('Your Drawer is Empty, Add it up! | 0/' + $totalStep);
    }
        
    //Switch the tab to pending
    $chooseText = $('.choose-wrapper .choose');
    $pendingStep = $('.drawer-head[data-action="pending"]');
    if($pendingStep.length > 0) {      
      $($pendingStep[0]).find('a').click();
    }
    
    //Update Choose Text
    $chooseText = $('.choose-wrapper .choose');
    var $getActiveHtml = $('.drawer-head.active');
    var $textMe = $('.drawer-head.active .head-title-text').html();
    if($getActiveHtml.attr('data-action') == 'completed') {
      $chooseText.html($textMe + ' Added');
    } else {
      $chooseText.html('Choose ' + $textMe);
    }
       
    var $variantOldArray = JSON.parse(localStorage.getItem($pageHandle));
   
    //Update the array and save it in local storage
    if($variantOldArray) {
      $variantOldArray.push({variant_id: $variantId, product_id: $productId, drawer: $drawerName, image: $drawerImage, action: $activeTab.attr('data-action')});         
      localStorage.setItem($pageHandle, JSON.stringify($variantOldArray));
    } else {
      $variantArray.push({variant_id: $variantId, product_id: $productId, drawer: $drawerName, image: $drawerImage, action: $activeTab.attr('data-action')});
      localStorage.setItem($pageHandle, JSON.stringify($variantArray));
    }
    
    $dataArray = JSON.parse(localStorage.getItem($pageHandle));
    
    //Open Add To Cart Modal
    var $cartModalHtml = "", $getValuesFromArray,
    	$stepCompleted = $('.drawer-head[data-action="completed"]').length;

    if($variantOldArray) {
      $getValuesFromArray = $variantOldArray;
    } else {
      $getValuesFromArray = $variantArray;
    }	
        
    if($totalStep == $stepCompleted) {
      $.each($getValuesFromArray, function(key, val) {
        $cartModalHtml += '<div class="cart-image-wrapper" data-variant-id="' + val.variant_id + '" drawer-name="' + val.drawer + '">';
        $cartModalHtml += '<div class="remove-item" data-variant="' + val.variant_id + '" drawer-name="' + val.drawer + '">';
        $cartModalHtml += '<span aria-hidden="true">✕</span></div>';
        $cartModalHtml += '<img src="' + val.image + '" alt="Closet Image" />'
        $cartModalHtml += '</div>';
      });
      
      $('#cartBody').html($cartModalHtml);      
      setTimeout(function(){ 
      	$('#cartModal').modal('show');
      }, 500);      
    } 
    
    //Scroll to top
    $("html, body").stop().animate({scrollTop:0}, 500);
    
    //Show and hide loader
    $('#loader').show();
    setTimeout(function(){ 
      $('#loader').hide();
    }, 2000);    
     
  });

  
  /*====================================================================*\
		#Get the local storage value 
         then loop through it to find the already added products.			
  \*====================================================================*/
  $dataArray = JSON.parse(localStorage.getItem($pageHandle));
  
  $.each($dataArray, function(key, value) {
    
    //Show Active Tabs
    $activeTab = $('.drawer-head[drawer-count="' + value.drawer + '"]');
    $activeTab.find('.drawer-link-details').hide();
    $activeTab.find('.drawer-active-link').show();
    $activeTab.find('.drawer-active-link img').attr('src', value.image);
    $activeTab.find('.drawer-active-link .remove-item').attr('data-variant', value.variant_id);
    
    //Update tab class pending to completed
    $activeTab.attr('data-action', value.action);
        
    //Hide Buttons
    $('.product_des_wrapper[drawer-count='+ value.drawer +']').find(".drawer__form").hide();
    $('.product_des_wrapper[drawer-count='+ value.drawer +']').find(".drawer__button").hide();
        
  });
  
  //Update Progress Bar
  $completedStep = (100 * ($('.drawer-head[data-action="completed"]').length)) / $totalStep;
  $step.find('span').css('width', $completedStep + '%');
  
  //Update Progress Bar Text
  $progressText = $('.counter-text');
  $stepCompleted = $('.drawer-head[data-action="completed"]').length;
  if($stepCompleted > 0) {
    $progressText.html('Your Pack | ' + $stepCompleted + '/' + $totalStep);
  } else {
    $progressText.html('Your Drawer is Empty, Add it up! | 0/' + $totalStep);
  }
          
  //Open Add To Cart Modal
  var $cartModalHtml = "",
      $stepCompleted = $('.drawer-head[data-action="completed"]').length;

  if($totalStep == $stepCompleted) {
    $.each($dataArray, function(key, value) {
      $cartModalHtml += '<div class="cart-image-wrapper" data-variant-id="' + value.variant_id + '" drawer-name="' + value.drawer + '">';
      $cartModalHtml += '<div class="remove-item" data-variant="' + value.variant_id + '" drawer-name="' + value.drawer + '">';
      $cartModalHtml += '<span aria-hidden="true">✕</span></div>';
      $cartModalHtml += '<img src="' + value.image + '" alt="Closet Image" />'
      $cartModalHtml += '</div>';
    });
       
    $('#cartBody').html($cartModalHtml);
    $('#cartModal').modal('show');
  } 

  //Switch the tab to pending
  $pendingStep = $('.drawer-head[data-action="pending"]');
  if($pendingStep.length > 0) {    
    $($pendingStep[0]).find('a').click();
  }
  
  //Update Choose Text
  $chooseText = $('.choose-wrapper .choose');
  var $getActiveHtml = $('.drawer-head.active');
  var $textMe = $('.drawer-head.active .head-title-text').html();
  if($getActiveHtml.attr('data-action') == 'completed') {
	$chooseText.html($textMe + ' Added');
  } else {
    $chooseText.html('Choose ' + $textMe);
  }
  
  /*==========================================*\
			   #Remove Item from Tab			
  \*==========================================*/
  $(document).on('click', '.remove-item', function() {
  	var $getVariantId = $(this).attr('data-variant');
    var $drawerCount = $(this).attr('drawer-name');
    
    //Remove data from array
    var $checkArray = $dataArray.findIndex(function(ele) {
      return ele.variant_id==$getVariantId;
    });
    if($checkArray!==-1) {
      $dataArray.splice($checkArray, 1);
    }
    
    //Reset Active Tabs
    $activeTab = $('.drawer-head[drawer-count="' + $drawerCount + '"]');
    $activeTab.find('.drawer-link-details').show();
    $activeTab.find('.drawer-active-link').hide();
    $activeTab.find('.drawer-active-link img').attr('src', '');
    $activeTab.find('.drawer-active-link .remove-item').attr('data-variant', '');
    
    //Update tab class completed to pending
    $activeTab.attr('data-action', 'pending');
    
    //Update Progress Bar
    $completedStep = (100 * ($('.drawer-head[data-action="completed"]').length)) / $totalStep;
    $step.find('span').css('width', $completedStep + '%');
    
    //Update Progress Bar Text
    $progressText = $('.counter-text');
    $stepCompleted = $('.drawer-head[data-action="completed"]').length;
    if($stepCompleted > 0) {
      $progressText.html('Your Pack | ' + $stepCompleted + '/' + $totalStep);
    } else {
      $progressText.html('Your Drawer is Empty, Add it up! | 0/' + $totalStep);
    }
        
    //Switch the tab to pending
    $pendingStep = $('.drawer-head[data-action="pending"]');
    if($pendingStep.length > 0) {
      console.log($pendingStep);
      $($pendingStep[$pendingStep.length]).find('a').click();
    }
    
    //Update Choose Text
    $chooseText = $('.choose-wrapper .choose');
    var $getActiveHtml = $('.drawer-head.active');
    var $textMe = $('.drawer-head.active .head-title-text').html();
    if($getActiveHtml.attr('data-action') == 'completed') {
      $chooseText.html($textMe + ' Added');
    } else {
      $chooseText.html('Choose ' + $textMe);
    }

    //Show Buttons
    if(window.innerWidth > 768) {
      $('.product_des_wrapper[drawer-count='+ $drawerCount +']').find(".drawer__form").show();    
    } else {
      $('.product_des_wrapper[drawer-count='+ $drawerCount +']').find(".drawer__button").show();
    }
    $(function() {
      $('.product_des_wrapper').matchHeight();
    });
    
    //Remove item from cart modal
    if($('#cartModal').length) {
      $(this).parent().hide();
      $('#cartModal').modal('hide');
    }

    //Update local Storage
	localStorage.setItem($pageHandle, JSON.stringify($dataArray));
  });
  
  /*==========================================*\
			 	#Add To Cart Button			
  \*==========================================*/
  var $allVariantId,
  	  $addCartBtn = $('#addToCart');
  	   
  $addCartBtn.on('click', function() {
    $allVariantId = $(this).parent().parent().find('.cart-image-wrapper');    
    var time = new Date().getTime(),
        self = $(this);
    
    self.attr('disabled', true)
    	.addClass('btn-disabled')
    	.html('Adding...');
    
    Shopify.queue = [];
    Shopify.moveAlong = function() {
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
      }
      else {
        $('#cartModal').modal('hide');
        setTimeout(function() {
          ajaxCart.load();
          timber.RightDrawer.open();
        }, 200);
        self.attr('disabled', false)
        .removeClass('btn-disabled')
        .html('Add To Cart');
      }
    }
    Shopify.addItem = function(id, qty, properties, callback) {
      var params = {
        quantity: qty,
        id: id
      };
      if(properties != false){
        params.properties = properties;
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function(){
          if(typeof callback === 'function'){
            callback();
          }
        },
        error: function(){}
      });
    }
    function push_to_queue(variantID, quantity, properties) {
      Shopify.queue.push({
        variantId: variantID,
        quantity: quantity,
        properties: properties
      });
    }    
    $.each($allVariantId, function(key, value) {
      var id = $(this).attr('data-variant-id');
      var darwer = $(this).attr('drawer-name');
      var concatData = darwer.concat(time);
      push_to_queue(id, 1, {drawer: time,page_handle:$pageHandle,productName:$drawerProductName});
    });
    
    
    //Edit Drawer
    var editDrawerLines = $.cookie('drawerEditLines'),
        lineArray = [];
    if(editDrawerLines != undefined) {
      lineArray = editDrawerLines.split(',');
      
      //Edit Drawer    
      Shopify.editDrawer = [];   
      Shopify.editAlong = function() {
        if(Shopify.editDrawer.length) {
          var request = Shopify.editDrawer.shift();
          Shopify.editItem(request.line, request.quantity, Shopify.editAlong);
        } else {
          //Add To Cart
          Shopify.moveAlong();
          
          //Remove cookies
          $.removeCookie('drawerEditLines');
          $.removeCookie('drawerPageHandle');
          $.removeCookie('drawerEditLines', { path: '/' });
          $.removeCookie('drawerPageHandle', { path: '/' });
        }
      }    
      Shopify.editItem = function(line, quantity, callback) {
        var params = {
          quantity: quantity,
          line: line
        };
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: params,
          success: function(){
            if(typeof callback === 'function'){
              callback();
            }
          },
          error: function(){}
        });
      }    
      function editDrawerQueue(line, quantity) {
        Shopify.editDrawer.push({
          line: line,
          quantity: quantity
        });
      } 
      
      $.each(lineArray, function(key, value) {
        if(value != '') {
          editDrawerQueue(lineArray[0], 0);
        }
      });
      Shopify.editAlong();
    } else {
      //Add To Cart
      Shopify.moveAlong(); 
    }
  });
  
  /*==========================================*\
			   #Restart Button			
  \*==========================================*/
  $(document).on('click', '.restartBtn', function() {
  	localStorage.removeItem($pageHandle);
    window.location.reload();
  });
  
  /*==========================================*\
			   #Tab Click Function		
  \*==========================================*/
  $('.drawer-link').on('click', function() {
    //Update Choose Text
    $chooseText = $('.choose-wrapper .choose');
    var $getActiveHtml = $('.drawer-head.active');
    var $textMe = $('.drawer-head.active .head-title-text').html();
    if($getActiveHtml.attr('data-action') == 'completed') {
      $chooseText.html($textMe + ' Added');
    } else {
      $chooseText.html('Choose ' + $textMe);
    }
  });
  
});

//Mobile Add To Cart
$(document).ready(function() {
  if (screen.width <= 768) {
    $(".span_close_button").click(function(){
      $(this).parents('.drawer__form').hide();
      $('.black-overlay').hide();
    });
  }
  $(document).on('click', '.addToCart', function(){    
    let $variantShow = $(this).parent().parent().parent().find('form .variants_wrapper').attr('data-variant');

    if($variantShow == "true") {
      $('.drawer__form').hide();
      $(this).parent().parent().parent().find('form').show();
      $('.unavailable_variant input').prop('checked', false);
      $('.black-overlay').show();
    } else {
	  $(this).parent().parent().parent().find('form .add-closet').click();
    }
  });
});


$(document).ready(function () {
  var $self, $variantShow, 
      $variantWrapper,
      $originalCloset,
      $dummyCloset = $('.dummy-closet');
  	  
  $dummyCloset.on('click', function() {
    $self = $(this);
    $originalCloset = $(this).parent().find('.add-closet');
  	$variantShow = $(this).parent().find('.variants_wrapper').attr('data-variant');
    $variantWrapper = $(this).parent().find('.variants_wrapper');
    
    if($variantShow == "true") {
      $('.variants_wrapper').hide();
      $('.dummy-closet').show();
      $self.hide();
      $variantWrapper.css('display', 'flex');
    } else {
      $originalCloset.click();
    }    
  });
  
  $('.swatch-element.available label').on('click', function(){  	
    $(this).parent().find('input').prop('checked', true);
    $('.unavailable_variant input').prop('checked', false);
    var currentVariant = $(this).parent().find('input').val();
    $('.product-variant-list').val(currentVariant).trigger('change');
    $(this).parent().parent().parent().find('.add-closet').click();
  });
});